"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RefreshBodyDto = void 0;
class RefreshBodyDto {
}
exports.RefreshBodyDto = RefreshBodyDto;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVmcmVzaEJvZHlEdG8uanMiLCJzb3VyY2VSb290IjoiLi9zcmMvIiwic291cmNlcyI6WyJwYWNrYWdlcy9tb2RlbHMvZHRvL3JlZnJlc2hCb2R5RHRvLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLE1BQWEsY0FBYztDQUcxQjtBQUhELHdDQUdDIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGNsYXNzIFJlZnJlc2hCb2R5RHRvIHtcbiAgICByZWZyZXNoVG9rZW46IHN0cmluZztcbiAgICAvLyBpc01vYmlsZT86IHN0cmluZztcbn0iXX0=